import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { RentalAgreementRecordCategoryEnum } from '../enums/rental-agreement-record-category.enum';
import { RentalAgreementStatusEnum } from '../enums/rental-agreement-status.enum';
import { RentalAgreementTypeEnum } from '../enums/rental-agreement-type.enum';

/**
 * Rental agreements filters
 */
export class RentalAgreementsFilters extends ApiRequestFilters {
	/**
	 * Customers id values
	 */
	customers?: number[];

	/**
	 * Account uuids on a party, booker or driver.
	 */
	accounts?: string[];

	/**
	 * Agents id values
	 */
	agents?: number[];

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Vehicles category values
	 */
	vehicleCategories?: number[];

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossFrom?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossTo?: number;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-in from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-in to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Check-out locations id values
	 */
	checkOutLocations?: number[];

	/**
	 * Check-in locations id values
	 */
	checkInLocations?: number[];

	/**
	 * Pickup locations id values
	 */
	pickupLocations?: number[];

	/**
	 * Drop off locations id values
	 */
	dropOffLocations?: number[];

	/**
	 * Status values
	 */
	statuses?: RentalAgreementStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: RentalAgreementRecordCategoryEnum[];

	/**
	 * Type enum values
	 */
	types?: RentalAgreementTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
